export const isIE = () => {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf("MSIE ");

    return msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./);
};

export const isMobile = () => {
    return window.innerWidth < 768;
};
export const isTablet = () => {
    return window.innerWidth < 1024;
};
export const isTabletPortrait = () => {
    return window.innerWidth < 1024 && window.innerWidth < window.innerHeight;
};

export const persistedState = (name) => {
    try {
        const serializedState = localStorage.getItem(name);
        if (serializedState === null) {
            return false;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return false;
    }
};

export const savePersistedState = (name, state) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem(name, serializedState);
    } catch (err) {
        return undefined;
    }
};


// WEBPACK FOOTER //
// ./sources/js/base/common.js